import {
  MiBox,
  MiBuildPageHeader,
  MiIcon,
  MiList,
} from "@miplatform/components";
import { ICONS_WEB, PAGINATION } from "@miplatform/constants";
import { useRouter } from "@miplatform/hooks";
import * as mdi from "@mdi/js";
import { useTheme } from "@mui/material";
import { usePlansViewModel } from "./usePlansViewModel";

export function Plans() {
  const { navigate } = useRouter();
  const {
    isLoading,
    accounts,
    search,
    debouncedSearch,
    setSearch,
    setAccounts,
    getAccounts,
    getRecentAccounts,
    setRecentAccounts,
    recentAccounts,
  } = usePlansViewModel();
  const theme = useTheme();

  const sections = [
    {
      fieldset: [
        {
          label: "Name",
          field: "name",
        },
        {
          label: "Abbreviation",
          field: "code",
        },
        {
          label: "Status",
          field: "status",
        },
        {
          label: "Address",
          field: "address",
          renderValue: ({ address }) =>
            `${address.addressLine1}, ${address.city}, ${address.regionCode} ${address.postalCode}`,
        },
      ],
    },
  ];

  return (
    <>
      <MiBuildPageHeader
        title="Bids"
        loading={isLoading}
        search={search}
        onHandleSearch={(e) => setSearch(e.target.value)}
        titleIcon={
          <MiIcon
            path={mdi[ICONS_WEB.VIEW_COMPACT]}
            color={theme.palette.primary.main}
          />
        }
        actionContainerStyle={{
          flexWrap: "nowrap",
        }}
      />
      <MiBox>
        <MiList
          viewType="card"
          showRecent
          paginationMode={PAGINATION.SERVER}
          loading={isLoading}
          search={debouncedSearch}
          data={accounts}
          setData={setAccounts}
          dataProvider={getAccounts}
          recentData={recentAccounts}
          setRecentData={setRecentAccounts}
          recentDataProvider={getRecentAccounts}
          cardProps={{
            sections,
            onClick: (item) => navigate(`/estimating/old-bids/${item.id}`),
          }}
          emptyListProps={{
            text: "No Customers found",
          }}
          data-testid="plans-list"
        />
      </MiBox>
    </>
  );
}
